import { useEffect, useRef } from "react";

// Animated seismograph trace shown during the 2s uncertainty reveal.
export function Seismograph({ label = "Analyzing seismic intensity…" }) {
  const canvasRef = useRef();
  const raf = useRef();

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const W = (canvas.width = canvas.clientWidth * 2);
    const H = (canvas.height = canvas.clientHeight * 2);
    let t = 0;
    const draw = () => {
      ctx.clearRect(0, 0, W, H);
      ctx.strokeStyle = "rgba(239,68,68,0.25)";
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(0, H / 2);
      ctx.lineTo(W, H / 2);
      ctx.stroke();
      ctx.strokeStyle = "#ef4444";
      ctx.lineWidth = 3;
      ctx.shadowColor = "rgba(239,68,68,0.7)";
      ctx.shadowBlur = 8;
      ctx.beginPath();
      for (let x = 0; x < W; x += 4) {
        const spike = Math.sin(x * 0.05 + t) * Math.sin(x * 0.013 + t * 0.7);
        const noise = (Math.random() - 0.5) * 0.6;
        const y = H / 2 + (spike + noise) * H * 0.36;
        x === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
      }
      ctx.stroke();
      t += 0.35;
      raf.current = requestAnimationFrame(draw);
    };
    draw();
    return () => cancelAnimationFrame(raf.current);
  }, []);

  return (
    <div className="w-full">
      <div className="text-xs font-semibold uppercase tracking-wide text-red-300 mb-1 font-mono-tele animate-pulse">{label}</div>
      <canvas ref={canvasRef} className="w-full h-16 rounded-lg bg-black/50 border border-red-500/30" />
    </div>
  );
}
